import _slicedToArray from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { Material } from 'three';
var $threeGLTF = Symbol('threeGLTF');
var $gltf = Symbol('gltf');
var $gltfElementMap = Symbol('gltfElementMap');
var $threeObjectMap = Symbol('threeObjectMap');
var $parallelTraverseThreeScene = Symbol('parallelTraverseThreeScene');
var $correlateOriginalThreeGLTF = Symbol('correlateOriginalThreeGLTF');
var $correlateCloneThreeGLTF = Symbol('correlateCloneThreeGLTF');
/**
 * The Three.js GLTFLoader provides us with an in-memory representation
 * of a glTF in terms of Three.js constructs. It also provides us with a copy
 * of the deserialized glTF without any Three.js decoration, and a mapping of
 * glTF elements to their corresponding Three.js constructs.
 *
 * A CorrelatedSceneGraph exposes a synchronously available mapping of glTF
 * element references to their corresponding Three.js constructs.
 */
export var CorrelatedSceneGraph = /*#__PURE__*/function () {
  function CorrelatedSceneGraph(threeGLTF, gltf, threeObjectMap, gltfElementMap) {
    _classCallCheck(this, CorrelatedSceneGraph);
    this[$threeGLTF] = threeGLTF;
    this[$gltf] = gltf;
    this[$gltfElementMap] = gltfElementMap;
    this[$threeObjectMap] = threeObjectMap;
  }
  /**
   * Produce a CorrelatedSceneGraph from a naturally generated Three.js GLTF.
   * Such GLTFs are produced by Three.js' GLTFLoader, and contain cached
   * details that expedite the correlation step.
   *
   * If a CorrelatedSceneGraph is provided as the second argument, re-correlates
   * a cloned Three.js GLTF with a clone of the glTF hierarchy used to produce
   * the upstream Three.js GLTF that the clone was created from. The result
   * CorrelatedSceneGraph is representative of the cloned hierarchy.
   */
  _createClass(CorrelatedSceneGraph, [{
    key: "threeGLTF",
    get:
    /**
     * The source Three.js GLTF result given to us by a Three.js GLTFLoader.
     */
    function get() {
      return this[$threeGLTF];
    }
    /**
     * The in-memory deserialized source glTF.
     */
  }, {
    key: "gltf",
    get: function get() {
      return this[$gltf];
    }
    /**
     * A Map of glTF element references to arrays of corresponding Three.js
     * object references. Three.js objects are kept in arrays to account for
     * cases where more than one Three.js object corresponds to a single glTF
     * element.
     */
  }, {
    key: "gltfElementMap",
    get: function get() {
      return this[$gltfElementMap];
    }
    /**
     * A map of individual Three.js objects to corresponding elements in the
     * source glTF.
     */
  }, {
    key: "threeObjectMap",
    get: function get() {
      return this[$threeObjectMap];
    }
  }], [{
    key: "from",
    value: function from(threeGLTF, upstreamCorrelatedSceneGraph) {
      if (upstreamCorrelatedSceneGraph != null) {
        return this[$correlateCloneThreeGLTF](threeGLTF, upstreamCorrelatedSceneGraph);
      } else {
        return this[$correlateOriginalThreeGLTF](threeGLTF);
      }
    }
  }, {
    key: $correlateOriginalThreeGLTF,
    value: function value(threeGLTF) {
      var gltf = threeGLTF.parser.json;
      var associations = threeGLTF.parser.associations;
      var gltfElementMap = new Map();
      var defaultMaterial = {
        name: 'Default'
      };
      var defaultReference = {
        type: 'materials',
        index: -1
      };
      var _iterator = _createForOfIteratorHelper(associations.keys()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var threeMaterial = _step.value;
          // Note: GLTFLoader creates a "default" material that has no
          // corresponding glTF element in the case that no materials are
          // specified in the source glTF. In this case we append a default
          // material to allow this to be operated upon.
          if (threeMaterial instanceof Material && associations.get(threeMaterial) == null) {
            if (defaultReference.index < 0) {
              if (gltf.materials == null) {
                gltf.materials = [];
              }
              defaultReference.index = gltf.materials.length;
              gltf.materials.push(defaultMaterial);
            }
            threeMaterial.name = defaultMaterial.name;
            associations.set(threeMaterial, {
              materials: defaultReference.index
            });
          }
        }
        // Creates a reverse look up map (gltf-object to Three-object)
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(associations),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            threeObject = _step2$value[0],
            gltfMappings = _step2$value[1];
          if (gltfMappings) {
            threeObject.userData = threeObject.userData || {};
            threeObject.userData.associations = gltfMappings;
          }
          for (var mapping in gltfMappings) {
            if (mapping != null && mapping !== 'primitives') {
              var type = mapping;
              var elementArray = gltf[type] || [];
              var gltfElement = elementArray[gltfMappings[type]];
              if (gltfElement == null) {
                // TODO: Maybe throw here...
                continue;
              }
              var threeObjects = gltfElementMap.get(gltfElement);
              if (threeObjects == null) {
                threeObjects = new Set();
                gltfElementMap.set(gltfElement, threeObjects);
              }
              threeObjects.add(threeObject);
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return new CorrelatedSceneGraph(threeGLTF, gltf, associations, gltfElementMap);
    }
    /**
     * Transfers the association between a raw glTF and a Three.js scene graph
     * to a clone of the Three.js scene graph, resolved as a new
     * CorrelatedSceneGraph instance.
     */
  }, {
    key: $correlateCloneThreeGLTF,
    value: function value(cloneThreeGLTF, upstreamCorrelatedSceneGraph) {
      var originalThreeGLTF = upstreamCorrelatedSceneGraph.threeGLTF;
      var originalGLTF = upstreamCorrelatedSceneGraph.gltf;
      var cloneGLTF = JSON.parse(JSON.stringify(originalGLTF));
      var cloneThreeObjectMap = new Map();
      var cloneGLTFElementMap = new Map();
      for (var i = 0; i < originalThreeGLTF.scenes.length; i++) {
        this[$parallelTraverseThreeScene](originalThreeGLTF.scenes[i], cloneThreeGLTF.scenes[i], function (object, cloneObject) {
          var elementReference = upstreamCorrelatedSceneGraph.threeObjectMap.get(object);
          if (elementReference == null) {
            return;
          }
          for (var mapping in elementReference) {
            if (mapping != null && mapping !== 'primitives') {
              var type = mapping;
              var index = elementReference[type];
              var cloneElement = cloneGLTF[type][index];
              var mappings = cloneThreeObjectMap.get(cloneObject) || {};
              mappings[type] = index;
              cloneThreeObjectMap.set(cloneObject, mappings);
              var cloneObjects = cloneGLTFElementMap.get(cloneElement) || new Set();
              cloneObjects.add(cloneObject);
              cloneGLTFElementMap.set(cloneElement, cloneObjects);
            }
          }
        });
      }
      return new CorrelatedSceneGraph(cloneThreeGLTF, cloneGLTF, cloneThreeObjectMap, cloneGLTFElementMap);
    }
    /**
     * Traverses two presumably identical Three.js scenes, and invokes a
     * callback for each Object3D or Material encountered, including the initial
     * scene. Adapted from
     * https://github.com/mrdoob/three.js/blob/7c1424c5819ab622a346dd630ee4e6431388021e/examples/jsm/utils/SkeletonUtils.js#L586-L596
     */
  }, {
    key: $parallelTraverseThreeScene,
    value: function value(sceneOne, sceneTwo, callback) {
      var traverse = function traverse(a, b) {
        callback(a, b);
        if (a.isObject3D) {
          var meshA = a;
          var meshB = b;
          if (meshA.material) {
            if (Array.isArray(meshA.material)) {
              for (var i = 0; i < meshA.material.length; ++i) {
                callback(meshA.material[i], meshB.material[i]);
              }
            } else {
              callback(meshA.material, meshB.material);
            }
          }
          for (var _i = 0; _i < a.children.length; ++_i) {
            traverse(a.children[_i], b.children[_i]);
          }
        }
      };
      traverse(sceneOne, sceneTwo);
    }
  }]);
  return CorrelatedSceneGraph;
}();